/* ══════════════════════════════════════════════════════════════════════
   PUBLISHING INSIGHTS — search v2
   ─────────────────────────────────────────────────────────────────────
   Replaces the old hero field, whose problem was never the matching: the
   input sat ~1,200px above the grid it filtered, so on a phone you typed
   and NOTHING on screen changed.  Here the results come to the input.

   • The trigger opens a sheet (full-height on phones, a centred dialog on
     desktop) with the results directly under the field.
   • Matching is token-based and scored, so "book marketing" and a typo
     like "royaltis" both work — the old code was one substring test over
     the whole card, dates and "Read more" included.
   • "Show N articles on the page" hands the query back to the existing
     grid filter and scrolls there, so the two never disagree.

   It reads the cards already in the DOM (.post inside #postGrid), so it
   needs no index file and no network call, and on Shopify it sees every
   article the paginated grid rendered.
   ══════════════════════════════════════════════════════════════════════ */
(function(){
  if (window.__tsxInit) return;
  window.__tsxInit = true;

  var MAX_RESULTS = 24;

  /* Genuinely different words a reader may reach for.  Prefix + stem
     matching already covers royalty/royalties and market/marketing, so
     this list is only for the cases those cannot reach. */
  var SYN = {
    cost:['price','fee','budget','charge','expensive','cheap','afford'],
    price:['cost','fee','budget'],
    royalty:['earning','payment','percentage','profit','revenue','pay'],
    earning:['royalty','profit','revenue'],
    marketing:['promote','promotion','publicity','advertise','sell','sales','launch'],
    promote:['marketing','publicity'],
    submit:['submission','send','pitch','apply','manuscript'],
    submission:['submit','pitch','manuscript','apply'],
    manuscript:['submission','draft','submit'],
    indie:['self','independent'],
    bestseller:['chart','top','selling'],
    edit:['editing','editor','proofread','revision'],
    anthology:['collection','collaborative'],
    traditional:['publisher','house','mainstream']
  };

  var STOP = { the:1, a:1, an:1, of:1, to:1, in:1, for:1, and:1, or:1, my:1, i:1, is:1, on:1, how:1 };

  /* ---------- text helpers ---------- */
  function norm(s){
    s = (s || '').toLowerCase();
    /* strip accents so a pasted or curly-typed word still matches */
    return s.normalize ? s.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : s;
  }
  function words(s){
    return norm(s).replace(/[^a-z0-9]+/g,' ').trim().split(' ').filter(Boolean);
  }
  function stem(w){
    if (w.length <= 3) return w;
    if (/ies$/.test(w)) return w.slice(0,-3) + 'y';
    if (/(ing|ers|ed)$/.test(w) && w.length > 5) return w.replace(/(ing|ers|ed)$/,'');
    if (/(es|er|s)$/.test(w) && w.length > 4) return w.replace(/(es|er|s)$/,'');
    return w;
  }
  /* one-edit distance — a single slipped, missing or swapped letter, no more.
     Short words are excluded by the caller: at 4 letters, one edit reaches
     far too many unrelated words. */
  function near(a,b){
    if (a === b) return true;
    if (a.length > b.length){ var t = a; a = b; b = t; }
    var la = a.length, lb = b.length;
    if (lb - la > 1) return false;
    var i = 0, j = 0, diff = 0;
    while (i < la && j < lb){
      if (a[i] === b[j]){ i++; j++; continue; }
      if (++diff > 1) return false;
      if (la === lb){ i++; j++; } else { j++; }
    }
    return diff + (la - i) + (lb - j) <= 1;
  }

  /* ---------- the index, read straight off the rendered cards ----------
     The cards carry a title, a category and a ONE-LINE summary.  That is not
     what a reader searches for: 11 of the 25 articles discuss ISBN in the
     body and not one of them says it in the summary, so "isbn" found nothing.

     data-body carries a deduplicated word list for the article, searched at a
     low weight so a body mention never outranks a real title.  It is an
     ATTRIBUTE rather than a JSON blob on purpose — Liquid's `escape` makes an
     attribute safe with no escaping hazards, and words() strips punctuation
     client-side, so a stray newline or comma in it cannot break anything. */
  var INDEX = [];

  function build(){
    INDEX = [];
    matchCache = { q: null, set: null };
    Array.prototype.slice.call(document.querySelectorAll('#postGrid .post')).forEach(function(el, i){
      var link  = el.querySelector('.post-link') || el.querySelector('a[href]');
      var meta  = el.querySelector('meta[itemprop="url"]');
      var title = (el.querySelector('.post-t') || {}).textContent || '';
      var exc   = (el.querySelector('.post-x') || {}).textContent || '';
      var img   = el.querySelector('img');
      var time  = el.querySelector('time');
      var cats  = (el.getAttribute('data-cat') || '').split('|').map(function(t){ return t.trim(); }).filter(Boolean);
      INDEX.push({
        el: el, i: i,
        href: (link && link.getAttribute('href')) || (meta && meta.getAttribute('content')) || '#',
        title: title.trim(), excerpt: exc.trim(), cats: cats,
        date: time ? time.textContent.trim() : '',
        iso: time ? (time.getAttribute('datetime') || '') : '',
        img: img ? img.getAttribute('src') : '',
        alt: img ? (img.getAttribute('alt') || '') : '',
        wT: words(title), wC: words(cats.join(' ')), wX: words(exc),
        wB: words(el.getAttribute('data-body') || '')
      });
    });
  }

  /* ---------- scoring ----------
     TWO PASSES, and the order matters.  Pass 1 uses the typed word and its
     stem only.  Synonyms and typo-tolerance run in pass 2, and ONLY when
     pass 1 found nothing — otherwise "bestseller" widens to "best" and drags
     in every article whose summary happens to say "the best option", which
     is exactly how the first cut of this read as broken. */
  /* pass-2 only: the words a reader may reach for instead of ours */
  function expand(t){
    var out = [t], st = stem(t);
    if (SYN[t]) out = out.concat(SYN[t]);
    if (st !== t && SYN[st]) out = out.concat(SYN[st]);
    return out;
  }

  function fieldScore(list, tok, weight, wide){
    var best = 0, variants = wide ? expand(tok) : [tok];
    for (var v = 0; v < variants.length; v++){
      var q = variants[v], qs2 = stem(q), pen = v === 0 ? 1 : 0.5;
      for (var k = 0; k < list.length; k++){
        var w = list[k], sc = 0;
        if (w === q) sc = weight * 2.2;
        else if (w.indexOf(q) === 0 && q.length >= 3) sc = weight * 1.8;
        else if (stem(w) === qs2) sc = weight * 1.6;
        else if (q.length >= 4 && w.indexOf(q) !== -1) sc = weight;
        /* typo tolerance needs a long word — at 5+ letters one edit is a
           genuine slip, below that it is a different word */
        else if (wide && q.length >= 5 && near(w, q)) sc = weight * 0.5;
        sc *= pen;
        if (sc > best) best = sc;
      }
    }
    return best;
  }

  function pass(toks, nq, wide){
    var out = [];
    INDEX.forEach(function(r){
      var total = 0;
      for (var i = 0; i < toks.length; i++){
        var s = Math.max(fieldScore(r.wT, toks[i], 12, wide),
                         fieldScore(r.wC, toks[i], 8, wide),
                         fieldScore(r.wX, toks[i], 4, wide),
                         fieldScore(r.wB, toks[i], 1.5, wide));
        if (!s) return;              /* every word must land somewhere */
        total += s;
      }
      if (norm(r.title).indexOf(nq) !== -1) total += 28;
      else if (norm(r.excerpt).indexOf(nq) !== -1) total += 9;
      total += (INDEX.length - r.i) * 0.01;   /* newest breaks a tie */
      out.push({ r: r, s: total });
    });
    out.sort(function(a,b){ return b.s - a.s; });
    return out.map(function(o){ return o.r; });
  }

  /* true when a record matches ONLY in the body — the row then says so,
     rather than looking like a title match that isn't there */
  function bodyOnly(r, toks){
    for (var i = 0; i < toks.length; i++){
      if (fieldScore(r.wT, toks[i], 12, true) ||
          fieldScore(r.wC, toks[i], 8, true) ||
          fieldScore(r.wX, toks[i], 4, true)) return false;
    }
    return true;
  }
  var lastToks = [];

  var lastWasWide = false;
  function search(raw){
    var nq = norm(raw).trim();
    if (!nq) return null;
    var toks = words(raw).filter(function(t){ return !STOP[t]; });
    if (!toks.length) toks = words(raw);
    if (!toks.length) return null;
    lastToks = toks;

    var hits = pass(toks, nq, false);
    lastWasWide = false;
    if (!hits.length){
      hits = pass(toks, nq, true);
      lastWasWide = hits.length > 0;
    }
    /* still nothing: drop to ANY-word so a two-word query is not all-or-nothing */
    if (!hits.length && toks.length > 1){
      var seen = [];
      toks.forEach(function(t){
        pass([t], norm(t), true).forEach(function(r){ if (seen.indexOf(r) === -1) seen.push(r); });
      });
      hits = seen;
      lastWasWide = hits.length > 0;
    }
    return hits;
  }

  /* The page grid asks the SAME engine, so the panel and the filtered page
     can never disagree.  Cached by query — apply() calls this once per card,
     and without the cache every card would re-run the whole search. */
  var matchCache = { q: null, set: null };
  window.__tsxMatch = function(el, q){
    var key = q || '';
    if (matchCache.q !== key){
      var hits = search(key);
      matchCache = { q: key, set: hits ? hits.map(function(r){ return r.el; }) : null };
    }
    if (!matchCache.set) return true;      /* empty query filters nothing */
    return matchCache.set.indexOf(el) !== -1;
  };

  /* ---------- highlighting ---------- */
  function esc(s){
    return String(s).replace(/[&<>"']/g, function(c){
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }
  function mark(text, raw){
    var toks = words(raw).filter(function(t){ return t.length > 1 && !STOP[t]; });
    if (!toks.length) return esc(text);
    var flat = norm(text), out = '', at = 0;
    var spans = [];
    toks.forEach(function(t){
      var from = 0, k;
      while ((k = flat.indexOf(t, from)) !== -1){
        /* start of a word only — mid-word noise reads as a bug */
        if (k === 0 || !/[a-z0-9]/.test(flat[k-1])){
          var end = k + t.length;
          while (end < flat.length && /[a-z0-9]/.test(flat[end])) end++;
          spans.push([k, end]);
        }
        from = k + t.length;
      }
    });
    if (!spans.length) return esc(text);
    spans.sort(function(a,b){ return a[0]-b[0]; });
    var merged = [spans[0]];
    for (var i = 1; i < spans.length; i++){
      var last = merged[merged.length-1];
      /* also join across a single hyphen/apostrophe, so "self-publishing"
         highlights as one phrase rather than two boxes with a gap */
      var gap = flat.slice(last[1], spans[i][0]);
      if (spans[i][0] <= last[1] || (gap.length === 1 && !/[a-z0-9\s]/.test(gap)))
        last[1] = Math.max(last[1], spans[i][1]);
      else merged.push(spans[i]);
    }
    merged.forEach(function(sp){
      out += esc(text.slice(at, sp[0])) + '<mark>' + esc(text.slice(sp[0], sp[1])) + '</mark>';
      at = sp[1];
    });
    return out + esc(text.slice(at));
  }

  /* ---------- the overlay ---------- */
  var ICON_MAG  = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="M21 21l-4.3-4.3"></path></svg>';
  var ICON_X    = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>';

  var root, panel, input, clearBtn, bodyEl, statusEl, footEl, applyBtn, scrim;
  var results = [], cur = -1, opened = false, lastFocus = null, scrollY = 0;

  function makeUI(){
    root = document.createElement('div');
    root.className = 'tsx-root';
    root.innerHTML =
      '<div class="tsx-scrim" data-close></div>' +
      '<div class="tsx-panel" role="dialog" aria-modal="true" aria-label="Search the blog">' +
        '<div class="tsx-head">' +
          '<div class="tsx-inwrap">' + ICON_MAG +
            '<input class="tsx-in" id="tsxIn" type="search" autocomplete="off" autocorrect="off" ' +
              'autocapitalize="off" spellcheck="false" role="combobox" aria-expanded="true" ' +
              'aria-controls="tsxList" aria-autocomplete="list" ' +
              'placeholder="Search articles">' +
            '<button class="tsx-clear" type="button" aria-label="Clear search">' + ICON_X + '</button>' +
          '</div>' +
          '<button class="tsx-close" type="button" data-close aria-label="Close search">' +
            ICON_X + '<span class="tsx-close-t">Close</span></button>' +
        '</div>' +
        '<div class="tsx-status"><span id="tsxCount" role="status" aria-live="polite"></span><span id="tsxHint"></span></div>' +
        '<div class="tsx-body" id="tsxList" role="listbox" aria-label="Search results"></div>' +
        '<div class="tsx-foot"><button class="tsx-apply" type="button">' + ICON_MAG + '<span>Show these on the page</span></button></div>' +
      '</div>';
    document.body.appendChild(root);

    panel    = root.querySelector('.tsx-panel');
    scrim    = root.querySelector('.tsx-scrim');
    input    = root.querySelector('.tsx-in');
    clearBtn = root.querySelector('.tsx-clear');
    bodyEl   = root.querySelector('.tsx-body');
    statusEl = root.querySelector('#tsxCount');
    footEl   = root.querySelector('.tsx-foot');
    applyBtn = root.querySelector('.tsx-apply');

    root.addEventListener('click', function(e){
      if (e.target.closest && e.target.closest('[data-close]')) close();
    });
    input.addEventListener('input', function(){ render(input.value); });
    input.addEventListener('keydown', onKey);
    clearBtn.addEventListener('click', function(){
      input.value = ''; render(''); input.focus();
    });
    applyBtn.addEventListener('click', function(){ applyToPage(input.value); });
  }

  function row(r, q, idx){
    var cat = r.cats[0] || '';
    var deep = q && lastToks.length && bodyOnly(r, lastToks);
    return '<a class="tsx-res" role="option" id="tsxR' + idx + '" aria-selected="false" href="' + esc(r.href) + '">' +
      (r.img ? '<span class="tsx-thumb"><img src="' + esc(r.img) + '" alt="" loading="lazy"></span>' : '') +
      '<span class="tsx-res-b">' +
        '<span class="tsx-res-m">' + (cat ? '<span>' + mark(cat, q) + '</span>' : '') +
          (r.date ? '<time>' + esc(r.date) + '</time>' : '') + '</span>' +
        '<span class="tsx-res-t">' + mark(r.title, q) + '</span>' +
        /* the marker rides the summary line: on a phone the meta row is
           already full, so a badge there wrapped and cost a whole line */
        '<span class="tsx-res-x">' + (deep ? '<b class="tsx-deep">In the article</b>' : '') +
          mark(r.excerpt, q) + '</span>' +
      '</span></a>';
  }

  function suggestions(){
    /* the categories actually on the page, plus the topics readers ask for */
    var cats = [];
    INDEX.forEach(function(r){ r.cats.forEach(function(c){ if (cats.indexOf(c) === -1) cats.push(c); }); });
    var topics = ['Royalties','Cost','Marketing','Submissions','Bestseller'];
    var html = '<div class="tsx-sug has-rail"><p class="tsx-sug-h">Browse by category</p><ul class="tsx-sug-list">';
    cats.forEach(function(c){ html += '<li><button class="tsx-tag" type="button" data-q="' + esc(c) + '">' + esc(c) + '</button></li>'; });
    html += '</ul></div>';
    html += '<div class="tsx-sug has-rail"><p class="tsx-sug-h">Popular searches</p><ul class="tsx-sug-list">';
    topics.forEach(function(t){ html += '<li><button class="tsx-tag" type="button" data-q="' + esc(t) + '">' + esc(t) + '</button></li>'; });
    html += '</ul></div>';

    var recent = INDEX.slice().sort(function(a,b){ return a.iso < b.iso ? 1 : -1; }).slice(0,4);
    html += '<div class="tsx-sug"><p class="tsx-sug-h">Latest articles</p></div>';
    recent.forEach(function(r, i){ html += row(r, '', i); });
    return html;
  }

  function render(q){
    var typed = (q || '').trim();
    clearBtn.classList.toggle('on', !!typed);
    cur = -1;

    if (!typed){
      results = [];
      bodyEl.innerHTML = suggestions();
      statusEl.innerHTML = '<b>' + INDEX.length + '</b> articles';
      root.querySelector('#tsxHint').textContent = 'Type to filter';
      footEl.classList.remove('on');
      bodyEl.scrollTop = 0;
      return;
    }

    results = (search(typed) || []).slice(0, MAX_RESULTS);
    var wide = lastWasWide;
    statusEl.innerHTML = results.length
      ? (wide ? 'Closest to' : '<b>' + results.length + '</b> ' +
          (results.length === 1 ? 'match for' : 'matches for')) +
        ' &ldquo;' + esc(typed) + '&rdquo;'
      : '<b>0</b> matches for &ldquo;' + esc(typed) + '&rdquo;';
    root.querySelector('#tsxHint').textContent =
      results.length ? (wide ? 'No exact match' : '') : 'No match';

    if (!results.length){
      /* never a dead end: offer the nearest topics instead */
      bodyEl.innerHTML =
        '<div class="tsx-none">' +
          '<p class="tsx-none-h">Nothing matches &ldquo;' + esc(typed) + '&rdquo;.</p>' +
          '<p class="tsx-none-p">Check the spelling, or try a broader word — ' +
            'we search titles, categories and summaries.</p>' +
        '</div>' + suggestions();
      footEl.classList.remove('on');
      bodyEl.scrollTop = 0;
      return;
    }

    bodyEl.innerHTML = results.map(function(r, i){ return row(r, typed, i); }).join('');
    applyBtn.querySelector('span').textContent =
      'Show ' + results.length + ' on the page';
    footEl.classList.add('on');
    bodyEl.scrollTop = 0;
  }

  function setCur(n){
    var rows = bodyEl.querySelectorAll('.tsx-res');
    if (!rows.length) return;
    if (cur > -1 && rows[cur]){ rows[cur].classList.remove('cur'); rows[cur].setAttribute('aria-selected','false'); }
    cur = (n + rows.length) % rows.length;
    rows[cur].classList.add('cur');
    rows[cur].setAttribute('aria-selected','true');
    input.setAttribute('aria-activedescendant', rows[cur].id || '');
    var r = rows[cur].getBoundingClientRect(), b = bodyEl.getBoundingClientRect();
    if (r.top < b.top) bodyEl.scrollTop -= (b.top - r.top) + 8;
    else if (r.bottom > b.bottom) bodyEl.scrollTop += (r.bottom - b.bottom) + 8;
  }

  function onKey(e){
    if (e.key === 'Escape'){ e.preventDefault(); close(); return; }
    if (e.key === 'ArrowDown'){ e.preventDefault(); setCur(cur + 1); return; }
    if (e.key === 'ArrowUp'){ e.preventDefault(); setCur(cur - 1); return; }
    if (e.key === 'Enter'){
      e.preventDefault();
      var rows = bodyEl.querySelectorAll('.tsx-res');
      if (cur > -1 && rows[cur]) rows[cur].click();
      else if (input.value.trim()) applyToPage(input.value);
    }
  }

  /* ---------- hand the query back to the page grid ---------- */
  var bar, barText;
  function makeBar(){
    var chipbar = document.querySelector('#chipbar');
    var host = chipbar && chipbar.parentNode;
    if (!host) return;
    bar = document.createElement('div');
    bar.className = 'tsx-bar tsx-root';
    bar.innerHTML =
      '<span class="tsx-bar-t" id="tsxBarT"></span>' +
      '<button class="tsx-bar-edit" type="button" data-edit>Edit search</button>' +
      '<button class="tsx-bar-clear" type="button" data-clear>Clear</button>';
    host.insertBefore(bar, chipbar.nextSibling);
    barText = bar.querySelector('#tsxBarT');
    bar.addEventListener('click', function(e){
      if (e.target.closest('[data-clear]')) applyToPage('');
      if (e.target.closest('[data-edit]')) open(input ? input.value : '');
    });
  }

  /* ⚠ Filtering moves cards that were far below the fold up into view, and
     the page's scroll-reveal set their inline opacity to 0 on load.  The
     IntersectionObserver does not reliably fire for an element that was
     RELAID OUT rather than scrolled to, so a result could arrive as a
     correctly-sized, correctly-linked, completely INVISIBLE card.  The
     reveal must never be the only route back to opacity. */
  function revealVisible(){
    Array.prototype.forEach.call(document.querySelectorAll('#postGrid .post'), function(p){
      if (!p.hidden) p.style.opacity = '';
    });
  }

  function applyToPage(q){
    var typed = (q || '').trim();
    if (typeof window.__twsBlogSetQuery === 'function') window.__twsBlogSetQuery(typed);
    revealVisible();

    /* the featured article is not part of the grid, so a live query would
       leave a non-matching post sitting above the results */
    var feat = document.querySelector('#featured');
    if (feat) feat.style.display = typed ? 'none' : '';

    if (bar){
      bar.classList.toggle('on', !!typed);
      if (typed){
        var n = (search(typed) || []).length;
        barText.innerHTML = 'Showing <b>' + n + '</b> ' + (n === 1 ? 'article' : 'articles') +
          ' for &ldquo;<b>' + esc(typed) + '</b>&rdquo;';
      }
    }
    close();
    if (typed){
      var target = document.querySelector('#articles');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    /* and again after the grid has settled, for anything Load more reveals */
    setTimeout(revealVisible, 60);
  }

  /* ---------- open / close ---------- */
  /* The card is centred on the VISIBLE area, not the layout viewport.  When
     the on-screen keyboard opens, visualViewport shrinks and offsets — without
     this the card would sit centred on the full screen, which puts its lower
     half behind the keys just as you start typing. */
  function fitViewport(){
    var vv = window.visualViewport;
    if (!vv || !root) return;
    root.style.setProperty('--tsx-vvh', vv.height + 'px');
    root.style.setProperty('--tsx-vvt', vv.offsetTop + 'px');
  }

  function open(seed){
    if (opened) return;
    opened = true;
    lastFocus = document.activeElement;
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.classList.add('tsx-lock');
    document.body.style.top = -scrollY + 'px';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    root.classList.add('open');
    fitViewport();
    if (window.visualViewport){
      window.visualViewport.addEventListener('resize', fitViewport);
      window.visualViewport.addEventListener('scroll', fitViewport);
    }
    input.value = seed || '';
    render(input.value);
    /* iOS only raises the keyboard for a focus inside the same gesture tick */
    input.focus();
    if (input.value) input.select();
  }
  function close(){
    if (!opened) return;
    opened = false;
    if (window.visualViewport){
      window.visualViewport.removeEventListener('resize', fitViewport);
      window.visualViewport.removeEventListener('scroll', fitViewport);
    }
    root.classList.remove('open');
    document.body.classList.remove('tsx-lock');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- wire the triggers ---------- */
  function wire(){
    Array.prototype.slice.call(document.querySelectorAll('[data-tsx-open]')).forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); open(''); });
    });
    /* a second way in, right beside the results */
    var chipbar = document.querySelector('#chipbar');
    if (chipbar) chipbar.addEventListener('click', function(){ setTimeout(revealVisible, 0); });
    var more = document.querySelector('#loadMore');
    if (more) more.addEventListener('click', function(){ setTimeout(revealVisible, 0); });
    if (chipbar && !chipbar.querySelector('.tsx-chipsearch')){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tsx-chipsearch tsx-root';
      b.innerHTML = ICON_MAG + '<span>Search</span>';
      b.addEventListener('click', function(){ open(''); });
      chipbar.insertBefore(b, chipbar.firstChild);
    }
    /* suggestion + category chips inside the panel */
    bodyEl.addEventListener('click', function(e){
      var t = e.target.closest && e.target.closest('[data-q]');
      if (!t) return;
      input.value = t.getAttribute('data-q');
      render(input.value);
      input.focus();
    });
    /* ⚠ NO '/' BINDING HERE.  assets/tws-search.js already claims '/' for the
       SITE-WIDE search, document-wide, so binding it here too opened both
       overlays at once on the blog page.  Cmd/Ctrl-K is unclaimed. */
    document.addEventListener('keydown', function(e){
      if (opened) return;
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)){ e.preventDefault(); open(''); }
    });
  }

  function boot(){
    if (!document.querySelector('#postGrid')) return;
    build();
    if (!INDEX.length) return;
    makeUI();
    makeBar();
    wire();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
